import classNames from 'classnames'

import { getPercentView } from '../../../../helpers/getPercentView'
import styles from '../../Revenue.module.scss'

interface IProps {
  value: number | null | string | undefined
  keyValue: string
}

export const ShortYoYRevenue = ({ value }: IProps) => {
  return (
    <p className={classNames(styles.textItem, styles.yoy, styles.alignColumns)}>
      {getPercentView(value !== null ? Number(value) : null)}
    </p>
  )
}
